import React, { useEffect, useState } from 'react';
import { EVENT_START, HACK_START, HACK_END, EVENT_END } from './data';

const parts = (ms) => [
  ['Days', Math.floor(ms / 864e5)], ['Hrs', Math.floor(ms / 36e5) % 24],
  ['Min', Math.floor(ms / 6e4) % 60], ['Sec', Math.floor(ms / 1e3) % 60],
];

// Dates carry the +05:30 offset, so the countdown is IST-accurate in any visitor timezone.
export const Countdown = () => {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);

  if (now >= EVENT_END) {
    return <p className="font-bold uppercase text-sm bg-[#111] text-[#F5F3EB] px-4 py-3 border-2 border-[#111]" data-testid="countdown-status">CONVERGE 2026 has wrapped. Thank you, builders.</p>;
  }
  if (now >= EVENT_START) {
    const hacking = now >= HACK_START;
    return (
      <p className="font-bold uppercase text-sm bg-[#FF6338] px-4 py-3 border-2 border-[#111] shadow-[4px_4px_0_#111]" data-testid="countdown-status">
        <span className="inline-block w-2.5 h-2.5 bg-[#111] mr-2 animate-pulse" />CONVERGE is live {now >= HACK_END ? '— awards & HR Conclave underway' : hacking ? '— the hackathon is underway' : '— Day 01 has begun'}
      </p>
    );
  }
  return (
    <div data-testid="countdown" aria-label="Countdown to CONVERGE (India Standard Time)">
      <p className="text-[10px] font-bold uppercase tracking-[0.25em] mb-2">Doors open in · IST</p>
      <div className="flex gap-2">
        {parts(EVENT_START - now).map(([label, v]) => (
          <div key={label} className="bg-white border-2 border-[#111] shadow-[3px_3px_0_#111] w-16 sm:w-[72px] py-2 text-center">
            <div className="cv-display text-2xl sm:text-3xl font-extrabold tabular-nums" data-testid={`countdown-${label.toLowerCase()}`}>{String(v).padStart(2, '0')}</div>
            <div className="text-[9px] font-bold uppercase tracking-widest">{label}</div>
          </div>
        ))}
      </div>
    </div>
  );
};
